<template>
  <el-select filterable :value="value" placeholder="课程" @change="handleInput" :clearable="true">
    <el-option
      v-for="item in items"
      :key="item.id"
      :label="item.title"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'LessonSelect',
  props: {
    value: Number
  },
  data () {
    return {
      items: []
    }
  },
  created () {
    this.initItems()
  },
  methods: {
    initItems () {
      this.$http.get(this.$urls.pinyin_lesson_list, {
        params: {
          page: 1,
          'per-page': 100
        }
      }).then(res => {
        this.items = res.data
      })
    },
    handleInput (val) {
      this.$emit('input', val)
    }
  }
}
</script>
